import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import produce from "immer";
import httpService from "services/httpService";
// import { persistor } from "..";

// AUTH
const requestStarted = (state = InitialState.userInfo, _action) => {
  return produce(state, (draftState) => {
    draftState.loading = true;
    draftState.error = null;
    draftState.msg = null;
  });
};

const requestCompleted = (state = InitialState.userInfo, action) => {
  return produce(state, (draftState) => {
    draftState.loading = false;
    draftState.msg = action.payload.msg;
    draftState.error = action.payload.error;
    // draftState.mode = action.payload.mode; //changed here
  });
};

const authSuccess = (state, action) => {
  
  return produce(state, (draftState) => {
    draftState.error = null;
    draftState.loading = false;
    draftState.is_instructor = null;
    draftState.token = action.payload.token;
    draftState.username = action.payload.username;
    draftState.email = action.payload.email;
    draftState.expirationDate = action.payload.expirationDate;
    draftState.userId = action.payload.userId;
    draftState.name = action.payload.name || action.payload.email;
   

    draftState.mode = action.payload.mode; // change made
    // draftState.msg = action.payload.msg;
  });
};

const authSignUpSuccess = (state, action) => {
  return produce(state, (draftState) => {
    draftState.loading = false;
    draftState.msg = action.payload.msg;
  });
};

const authFail = (state, action) => {
  return produce(state, (draftState) => {
    draftState.error = action.payload.error;
    draftState.loading = false;
  });
};

const authLogout = (state, _action) => {
  // persistor.purge();
  return produce(state, (draftState) => {

    draftState.token = null;
    draftState.username = null;
    draftState.loading = false;
    draftState.mode = null; //changed here
    draftState.is_instructor = null;
    draftState.userId = null;
    localStorage.removeItem("token");
    httpService.clearJwt();
  });
};
const modeChange = (state, action) => {
  
  return produce(state, (draftState) => {
    draftState.mode = action.payload.mode;
  });
};

const updateUserIsInstructor = (state, action) => {
  return produce(state, (draftState) => {
    draftState.is_instructor = action.payload.is_instructor;
  })
}


export function userAuthReducer(state = InitialState.userInfo, action) {

  switch (action.type) {
    //   AUTH
    case types.REQUEST_STARTED:
      return requestStarted(state, action);

    case types.REQUEST_COMPLETED:
      return requestCompleted(state, action);

    case types.AUTH_SUCCESS:
      return authSuccess(state, action);

    case types.AUTH_SIGNUP_SUCCESS:
      return authSignUpSuccess(state, action);

    case types.AUTH_FAIL:
      return authFail(state, action);

    case types.AUTH_LOGOUT:
      return authLogout(state, action);

    case types.MODE_CHANGE:
      return modeChange(state, action);

    case types.IS_INSTRUCTOR:
      return updateUserIsInstructor(state, action);
  }
  return state;
}
